export interface MoneyEventClassificationCoreInput {
  amountDueNow: number;
  configuredTrial: boolean;
  eventValue: number;
  hasPreview: boolean;
  previewScenario: string;
  priceType: "onetime" | "subscription" | "installments";
  trialIsFree: boolean;
}

export interface MoneyEventClassificationCore {
  eventName: "purchase" | "subscribe" | "start_trial";
  value: number;
}

const isValidMoneyAmount = (value: number) =>
  Number.isFinite(value) && value >= 0;

const isTrialFirstScenario = (scenario: string) =>
  scenario === "trial_then_value" ||
  scenario === "trial_then_upfront_then_value";

export const classifyMoneyEventCore = ({
  amountDueNow,
  configuredTrial,
  eventValue,
  hasPreview,
  priceType,
  previewScenario,
  trialIsFree,
}: MoneyEventClassificationCoreInput): MoneyEventClassificationCore | null => {
  if (!hasPreview || !isValidMoneyAmount(amountDueNow)) return null;

  if (
    amountDueNow === 0 &&
    configuredTrial &&
    isTrialFirstScenario(previewScenario) &&
    !trialIsFree
  ) {
    return null;
  }

  if (
    isTrialFirstScenario(previewScenario) &&
    trialIsFree &&
    amountDueNow === 0
  ) {
    return { eventName: "start_trial", value: 0 };
  }

  if (!isValidMoneyAmount(eventValue)) return null;
  return {
    eventName: priceType === "subscription" ? "subscribe" : "purchase",
    value: eventValue,
  };
};
